import React, { useState } from 'react'
import { Grid, Message, Button } from 'semantic-ui-react'
import CardsPrioritario from '../../components/CardsPrioritario'
import CardPautas from '../../components/CardPautas'
import { useHistory } from 'react-router'
import { useStore } from '../../stores/useStoreProfile'
import { PautasProvider } from '../../hooks/usePautas'

const Dashboard = () => {
  const [error, setError] = useState()
  const history = useHistory()
  const { store, modoApresentacao } = useStore()
  const { add_itemtrabalho, add_pauta } = store.permissions
  const canAddPrioritario = Boolean(add_itemtrabalho?.filter(e => e.tipo === 'tema_prioritario').length)
  const canAddPauta = Boolean(add_pauta?.filter(e => e.area_relatora).length)
  const showButtons = (canAddPrioritario || canAddPauta) && !modoApresentacao

  const onAddPrioritario = () => history.push('prioritario/novo')
  const onAddPauta = () => history.push('destaque/nova')

  return <Grid doubling stackable={true} className='dashboard'>
    {showButtons && <Grid.Row columns={1} verticalAlign='top'>
      <Grid.Column textAlign='right'>
        {canAddPrioritario && <Button
          name="btn-addprioritario"
          icon='plus'
          content='CARD'
          onClick={onAddPrioritario}
        />}
        {canAddPauta && <Button
          name="btn-addpauta"
          icon='plus'
          content='DESTAQUE'
          onClick={onAddPauta}
        />}
      </Grid.Column>
    </Grid.Row>}
    {error
      ? <Grid.Row columns={1}>
        <Grid.Column>
          <Message
            name="dash-errormsg"
            icon='times circle outline'
            negative
            header={error}
          />
        </Grid.Column>
      </Grid.Row>
      : null
    }
    <Grid.Row divided stretched reversed='computer tablet' verticalAlign='top'>
     <Grid.Column stackable='mobile tablet' computer={4} tablet={16} mobile={16}>
        <PautasProvider>
          <CardPautas  setError={setError} />
        </PautasProvider>
      </Grid.Column>
      <Grid.Column stretched computer={12} tablet={16} mobile={16}>
        <CardsPrioritario setError={setError} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
}

export default Dashboard
